import { createSelector } from '@reduxjs/toolkit';

import { getProjectIrisForModelId } from 'src/containers/ProjectDiagram/utils/projectModelIds';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectSelector } from 'src/selectors/project';

export const projectIrisForModelIdSelector = memoizeSelectorFactory(
  (projectId: string, modelId: string) =>
    createSelector(projectSelector(projectId), (project) =>
      project && modelId
        ? getProjectIrisForModelId(modelId, project.diagram.model)
        : []
    )
);
